import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store/state";
import { ResponseModel } from "../models/common/ResponseModel";
import { AxiosError } from "axios";
import { ARIA_SuccessCode, GetFunctionsResponseModel } from "models";
import { getFunctionListAPI } from "services/functionService";

const initialState: RootState.FunctionState = {
  functionList: [],
  error: undefined,
  isLoading: false,
};

//Actions
//More info here https://redux-toolkit.js.org/api/createAsyncThunk
export const fetchFunctionList = createAsyncThunk<
  GetFunctionsResponseModel,
  void,
  { rejectValue: AxiosError<Error> }
>("function/getFunctionList", async (_, thunkApi) => {
  try {
    var pageIndex = 1;

    let data: GetFunctionsResponseModel = await getFunctionListAPI({
      pageIndex,
      pageSize: 100,
    });

    let tempData = data.result.items;

    while (data.result.pageCount > pageIndex) {
      pageIndex++;
      let nextData: GetFunctionsResponseModel = await getFunctionListAPI({
        pageIndex,
        pageSize: 100,
      });

      tempData.push(...nextData.result.items);
    }

    data.result.items = tempData;

    return data;
  } catch (err) {
    let error = err as AxiosError<Error>; // cast the error for access
    if (!error.response) {
      throw err;
    }
    // We got validation errors, let's return those so we can reference in our component and set form errors
    return thunkApi.rejectWithValue(error);
  }
});

//Slice
//More info here https://redux-toolkit.js.org/api/createSlice
export const functionSlice = createSlice({
  name: "function",
  initialState,
  reducers: {
    //local reducer
    resetFunctionState() {
      return initialState;
    },
  },
  //services reducers
  extraReducers: (builder) => {
    builder.addCase(fetchFunctionList.fulfilled, (state, { payload }) => {
      if (payload.resultCode === ARIA_SuccessCode) {
        state.functionList = payload.result.items;
        state.error = undefined;
      } else {
        state.error = { ...payload };
      }

      state.error = undefined;
      state.isLoading = false;
    }),
      builder.addCase(fetchFunctionList.pending, (state, _) => {
        state.isLoading = true;
      }),
      builder.addCase(fetchFunctionList.rejected, (state, action) => {
        if (action.payload != undefined) {
          let error: AxiosError<Error> = action.payload;

          const serverError: ResponseModel = {
            resultCode: error?.response?.status.toString() ?? "",
            resultDescription: error?.response?.data.message ?? "",
          };

          state.error = serverError;
          state.isLoading = false;
        }
      });
  },
});

export const { resetFunctionState } =
functionSlice.actions;

export default functionSlice.reducer;
